var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,4.591V20.688l-12,3.332L0,20.688V4.591c0-.771,.339-1.496,.931-1.989,.021-.018,.047-.029,.069-.046V19.928l11,3.053,11-3.053V2.556c.022,.017,.047,.028,.069,.046,.592,.494,.931,1.219,.931,1.989ZM12,21.02l-9-2.572V3.501c0-.792,.363-1.519,.995-1.996,.633-.477,1.432-.624,2.192-.408l4.189,1.197c.679,.194,1.247,.624,1.624,1.185,.377-.561,.945-.991,1.624-1.185l4.189-1.197c.76-.217,1.56-.069,2.192,.408,.632,.477,.995,1.205,.995,1.996v14.947l-9,2.572Zm.5-1.183l7.5-2.143V3.501c0-.475-.218-.912-.597-1.198-.265-.199-.579-.303-.899-.303-.139,0-.278,.02-.416,.059l-4.19,1.197c-.823,.235-1.398,.998-1.398,1.854v14.727Zm-1-14.727c0-.857-.575-1.62-1.398-1.854l-4.189-1.197c-.457-.131-.935-.042-1.315,.244-.379,.286-.597,.723-.597,1.198v14.193l7.5,2.143V5.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.eefa0a747b7e60481f0011c6869cba72.svg";
export { ForwardRef as ReactComponent };